import { useRouter } from 'next/router';

const useBodyClass = () => {
	// destructuring asPath from next js useRouter hook to get the current path name
	const { asPath } = useRouter();

	// if path name returns slash it should be home
	if (asPath == '/') {
		var path = 'home';
	} else {
		// spliting path to convert string into array
		var pathName = asPath.split('?')[0];
		var newPathName = pathName.split('/');

		//removing empty array using filter and joining the path if have children with spaces
		var path = newPathName.filter((p) => p != '').join(' ');

		if (path.includes('prospectus')) {
			path = path + ' overview';
		}
	}

	return [path];
};

export default useBodyClass;
